module.exports = __webpack_public_path__ + "static/media/girl.b20a476a.png";